import { z } from 'zod';

// #195: `handover_received` / `handover_taken` (Weitergabe im Fachbereich) sind reine Glocke — nie
// Mail, nicht abbestellbar (siehe MAIL_PREFERENCE_KINDS).
// #194: `fix_rejected` (Melder verneint die Behebung, Glocke an den Bearbeiter) ist ebenfalls reine
// Glocke — nie Mail, nicht in MAIL_PREFERENCE_KINDS.
export const NOTIFICATION_KINDS = [
  'defect_assigned',
  'retest_due',
  'handover_received',
  'handover_taken',
  'fix_rejected',
] as const;
export const NotificationKindSchema = z.enum(NOTIFICATION_KINDS);
export type NotificationKind = z.infer<typeof NotificationKindSchema>;

// #202: Kontext, den der Server zu einer Benachrichtigung auflöst, damit die Glocke den konkreten
// Defect bzw. Testfall nennen kann. Ein fehlendes (gelöschtes oder projektfremdes) Objekt ist `null`
// — der Client fällt dann auf den bisherigen Satz zurück (G3).
export const NotificationContextSchema = z.object({
  defect: z
    .object({ defect_id: z.string().uuid(), human_id: z.string(), title: z.string() })
    .nullable(),
  test_case: z
    .object({
      test_case_id: z.string().uuid(),
      human_id: z.string(),
      title_de: z.string().nullable(),
      title_en: z.string().nullable(),
    })
    .nullable(),
});
export type NotificationContext = z.infer<typeof NotificationContextSchema>;

export const NotificationSchema = z.object({
  notification_id: z.string().uuid(),
  project_id: z.string().uuid(),
  kind: NotificationKindSchema,
  payload: z.record(z.unknown()),
  // #202: optional, damit alte Clients/Tests nicht brechen; `GET /notifications` setzt es immer.
  context: NotificationContextSchema.optional(),
  read_at: z.string().datetime().nullable(),
  created_at: z.string().datetime(),
});
export type Notification = z.infer<typeof NotificationSchema>;

// #129: Mail-Abmeldungen kennen zusätzlich den Tester-Digest. Er hat keine In-App-Zeile, deshalb
// bleiben NOTIFICATION_KINDS und das pgEnum unverändert.
// #195: bewusst EXPLIZIT statt aus NOTIFICATION_KINDS abgeleitet. Die Weitergabe-Arten sind reine
// Glocke; abgeleitet würden sie still zu abbestellbaren Mail-Arten (und `GET /me/notification-settings`
// lieferte plötzlich fünf statt drei Schlüssel).
export const MAIL_PREFERENCE_KINDS = ['defect_assigned', 'retest_due', 'tester_digest'] as const;
export type MailPreferenceKind = (typeof MAIL_PREFERENCE_KINDS)[number];

// Pro Mail-Typ ein Bool: true = mailen (Default). Fehlt der Eintrag ⇒ Default true.
export const NotificationSettingsSchema = z.object({
  defect_assigned: z.boolean(),
  retest_due: z.boolean(),
  tester_digest: z.boolean(),
});
export type NotificationSettings = z.infer<typeof NotificationSettingsSchema>;
